export default __webpack_public_path__ + "static/media/clouds_mini.d89d1217.jpg";